<aside class="main-sidebar sidebar-dark-primary elevation-4">
<!--<aside class="main-sidebar elevation-4 sidebar-proliga">-->

    <a [routerLink]="['/main/home']" class="brand-link">
        <img src="assets/img/main/isotipo_white@100x100.png" alt="League Sports isotipo" title="League Sports Isotipo" class="brand-image img-circle elevation-3" style="opacity: .8">
        <!-- <img src="assets/img/main/icon.png" alt="Proliga Isotipo" title="Proliga Isotipo" class="brand-image img-circle elevation-3" style="opacity: .8"> -->
        <span class="brand-text font-weight-light text-light"><b>{{CLUBNAME}}</b></span>
    </a>

    <div class="sidebar">

        <div class="user-panel mt-3 pb-3 mb-3 d-flex" [routerLink]="['/main/miperfil']" style="cursor: pointer;">
            
            <div class="image" *ngIf="cargandoUsuario">
                <div  class="spinner-border" role="status"></div>
            </div>


            <div class="image" *ngIf="!cargandoUsuario">
                <img [src]="usuario.urlimg | dropboxImagenDisplay:'person'" class="img-circle elevation-2" [alt]="usuario.nombres">
            </div>
            <div class="info" *ngIf="!cargandoUsuario">
                <a class="d-block">{{usuario.email}}</a>
                <a class="d-block">{{usuario.nombres}}</a>
            </div>
        </div>

        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/inicio']" routerLinkActive="active">
                        <i class="nav-icon fas fa-tachometer-alt"></i>
                        <p>Inicio</p>
                    </a>
                </li>
            </ul>
        </nav>

        <hr>

        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-header">PROPIEDADES</li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/ligas']" routerLinkActive="active">
                        <i class="nav-icon fas fa-trophy"></i>
                        <p>Mis Ligas</p>
                    </a>
                </li>
            </ul>
        </nav>

        <hr>

        <nav class="mt-2">

            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-header">ASIGNABLES</li>

                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/equipos']" routerLinkActive="active">
                        <i class="nav-icon fas fa-shield-alt"></i>
                        <p>Equipos </p>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/partidos']" routerLinkActive="active">
                        <i class="nav-icon fas fa-futbol"></i>
                        <p>Partidos </p>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/facturacion/']" routerLinkActive="active">
                        <i class="nav-icon fas fa-file-invoice"></i>
                        <p>Facturación </p>
                    </a>
                </li>
            </ul>
        </nav>

        <hr>

        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                <li class="nav-header">CONFIGURACIONES</li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/miperfil']" routerLinkActive="active">
                        <i class="nav-icon fas fa-user"></i>
                        <p>Mi perfil</p>
                    </a>
                </li>
            </ul>
        </nav>

        <hr>

        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                <li class="nav-header">LEAGUE SPORTS</li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/contacto']" routerLinkActive="active">
                        <i class="nav-icon fas fa-phone-alt"></i>
                        <p>Contacto</p>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/main/ayuda']" routerLinkActive="active">
                        <i class="nav-icon fas fa-question-circle"></i>
                        <p>Ayuda</p>
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" href="https://league-sports.com/privacy.html" target="_blank">
                        <i class="nav-icon fas fa-file"></i>
                        <p>Políticas de Privacidad</p>
                    </a>
                </li>
            </ul>
        </nav>


        <hr>

        <nav class="mt-2">
            <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                <li class="nav-header">SALIR</li>
                <li class="nav-item">
                    <a class="nav-link bg-danger" style="cursor: pointer;" (click)="logout()">
                        <i class="nav-icon fas fa-sign-out-alt"></i>
                        <p>Cerrar sesión</p>
                    </a>
                </li>
            </ul>
        </nav>



    </div>
</aside>